import { render, staticRenderFns } from "./RecommendBanner.vue?vue&type=template&id=ceb489ae"
import script from "./RecommendBanner.vue?vue&type=script&lang=js"
export * from "./RecommendBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports